require('./stylesheets/ke.style.scss');

angular.module('pages.kievenergy', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config ($stateProvider) {
	$stateProvider
		.state('pages.myelectricity', {
			url: 'myelectricity/:page',
			page:'',
			template: require('./templates/ke.template.html'),
			controller: require('./controllers/ke.controller'),
			data: {
				iframe: false,
				breadcrumbs: "MENU.MYELECTRICITY"
			},
			params: {
				page: null
			},
			pageTrack: '/myelectricity'
		});
}

module.exports = 'pages.kievenergy';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myElectricity/index.js
 ** module id = 275
 ** module chunks = 1
 **/